import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import {categoryDesigns} from './index'
import {createActions} from '../../../redux/actions/api'

const activities = createActions('stores', ['activities'], 'activities')

export const fetchActivities = (storeId) =>
  activities.get({path: `/${storeId}/activities`})

const orders = createActions('orders')

export const authorizeOrder = (body) =>
  orders.create({
    path: 'authorize',
    options: {body}
  })

export const fetchOrder = (orderId) => orders.get({path: `${orderId}`})

export const queryOrder = (query) => orders.get({query})

export const createOrder = (values) =>
  orders.create({
    path: values.orderID ? '/paypal' : undefined,
    options: {body: values}
  })

const storeTypes = createActions('store_types')

export const fetchStoreTypes = () => storeTypes.get({cached: true})

export const fetchStoreTypesByStoreType = (StoreType, cached = true) =>
  storeTypes.get({
    path: StoreType,
    merge: {StoreType},
    cached
  })

const subchannels = createActions('channels', ['subchannels'], 'subchannels')

export const fetchChannelsByChannelType = (type, subchannel) =>
  subchannels.get({
    path: type,
    query: {
      subchannel
    },
    merge: ['Key', type]
  })

const subchannelsTree = createActions(
  'channels',
  ['subchannelsTree'],
  'subchannelsTree'
)

export const fetchSubchannels = (type, subchannel) =>
  subchannelsTree.get({
    path: `${type}/subchannels/${subchannel}`
  })

const storeProducts = createActions(
  'stores',
  ['store_products'],
  'store_products'
)
const categoryProducts = createActions(
  'stores',
  ['category_products'],
  'category_products'
)

const productReviews = createActions(
  'stores',
  ['product_reviews'],
  'product_reviews'
)

const storeHomeProducts = createActions(
  'stores',
  ['store_home_products'],
  'store_home_products'
)

export const fetchProductsForCategory = (storeId, categoryId, activity) =>
  categoryProducts.get({
    path: `/${storeId}/categories/${categoryId}/products`,
    query: omitBy({activity}, isNil)
  })

const STORE_HOME_CATEGORY = 1724

export const fetchProductsForStoreHome = (storeId, activity) =>
  storeHomeProducts.get({
    path: `/${storeId}/categories/${STORE_HOME_CATEGORY}/products`,
    query: omitBy({activity}, isNil)
  })

export const fetchProductForStore = (storeId, productId) =>
  storeProducts.get({
    path: `${storeId}/products/${productId}`
  })

export const fetchReviewsForProduct = (storeId, productId, sortType, query) =>
  productReviews.get({
    path: `${storeId}/products/${productId}/reviews/${sortType}`,
    query: omitBy(query, isNil),
    append: !!query.lastId
  })

const designs = createActions('designs')

export const createDesign = (design) =>
  designs.create({path: '/custom', options: {body: design}})

export const fetchDesigns = (designIds, storeId, activity, cached) =>
  designs.get({
    query: omitBy({storeId, activity}, isNil),
    options: {method: 'POST', body: {DesignIds: designIds}},
    cached
  })

export const fetchDesignsForCategory = (
  storeId,
  categoryId,
  {activityTag, append = false, merge} = {}
) =>
  categoryDesigns.get({
    query: omitBy(
      {
        schoolid: storeId,
        category: categoryId,
        activity: activityTag
      },
      isNil
    ),
    append,
    merge
  })

const designEnums = createActions('designs', ['design_enums'], 'design_enums')

export const fetchDesignEnums = () =>
  designEnums.get({path: '/enums', cached: true})

const designQueue = createActions('designs', ['design_queue'], 'design_queue')

export const fetchDesignQueue = (cached = true) =>
  designQueue.get({path: '/queue', cached})

const category = createActions('stores', ['category'], 'category')

export const fetchCategoryById = (storeId, categoryId, cached) =>
  category.get({
    path: `/${storeId}/categories/${categoryId}`,
    cached
  })

const stores = createActions('stores')

export const fetchStore = (id, cached) => stores.get({path: id, cached})

const storesAdmin = createActions('stores', ['storeAdmin'], 'storeAdmin')
export const fetchStoreAdmin = (id, cached) =>
  storesAdmin.get({path: `${id}/admin`, cached})

const storeDesigns = createActions('stores', ['storeDesigns'], 'storeDesigns')
export const fetchStoreDesigns = (id, cached) =>
  storeDesigns.get({path: `${id}/designs`, cached})

export const updateStore = (id, values) =>
  stores.update({path: id, options: {body: values}, merge: {StoreId: id}})

const customDesigns = createActions(
  'stores',
  ['customDesigns'],
  'customDesigns'
)
export const createStoreCustomDesigns = (id, designs) =>
  customDesigns.create({
    path: `${id}/customDesigns`,
    options: {body: designs}
  })

export const fetchStoreCustomDesigns = (id, cached) =>
  customDesigns.get({path: `${id}/customDesigns`, cached})

export const removeStoreCustomDesign = (id, location) =>
  customDesigns.delete({
    path: `${id}/customDesigns/${location}`,
    merge: {Location: location},
    query: {}
  })

export const createStore = (store) => stores.create({options: {body: store}})

const claim = createActions('stores', ['storeClaim'], 'storeClaim')

export const claimStore = (id, body) =>
  claim.create({path: `${id}/claim`, options: {body}})

const signrequest = createActions('signrequest')

export const createSignRequest = (StoreID, EmailAddress) =>
  signrequest.create({options: {body: {StoreID, EmailAddress}}})

const stripe = createActions('stripe')

export const createStripeInvite = (StoreID, EmailAddress) =>
  stripe.create({
    path: 'invite',
    options: {body: {StoreID, EmailAddress}}
  })

export const cancelOrder = createActions(
  'orders',
  ['cancel_order'],
  'cancel_order'
)
